interface UseServiceWorkerReturnValue {
  cacheMedia (url: string[]): void
}

export function useServiceWorker (): UseServiceWorkerReturnValue {
  if (!('serviceWorker' in navigator)) {
    return {
      cacheMedia () {},
    }
  }

  const cacheMedia: UseServiceWorkerReturnValue['cacheMedia'] = (urls) => {
    const urlSet = new Set(urls.filter((url) => !!url))
    if (urlSet.size === 0) return
    navigator.serviceWorker.controller?.postMessage({
      type: 'cache-media',
      urls: [...urlSet],
    })
  }

  return {
    cacheMedia,
  }
}
